import React from "react"
import Video from "./Video/Video"

type EmbedYouTubeProps = {
  link: string
}

const YouTubeVideo = ({ link }: EmbedYouTubeProps) => {
  //
  const getYouTubeEmbedUrl = (link: string): string | null => {
    if (link.includes("youtube.com/embed/")) {
      return link
    }

    const regex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    const match = link.match(regex)
    return match
      ? `https://www.youtube.com/embed/${match[1]}?enablejsapi=1&mute=1&cc_load_policy=1`
      : null
  }

  const url = getYouTubeEmbedUrl(link)
  if (!url) {
    console.error("Invalid YouTube link provided:", link)
    return null
  }

  return <Video url={url} />
}

export default YouTubeVideo
